/**
 * @generated SignedSource<<ad95d79e0dba3f3dd000535923c8f688>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type utils_datasetExampleToEvaluatorInput_example$data = {
  readonly input: any;
  readonly metadata: any;
  readonly output: any;
  readonly " $fragmentType": "utils_datasetExampleToEvaluatorInput_example";
};
export type utils_datasetExampleToEvaluatorInput_example$key = {
  readonly " $data"?: utils_datasetExampleToEvaluatorInput_example$data;
  readonly " $fragmentSpreads": FragmentRefs<"utils_datasetExampleToEvaluatorInput_example">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "utils_datasetExampleToEvaluatorInput_example"
};

(node as any).hash = "2bc657d55c240986265a3810deb4eef4";

export default node;
